<template>
  <div>
    <div class="p-6 pb-0">
      <button @click="openAddUserModal" class="bg-blue-500 text-white px-4 py-2 mb-4 rounded-md shadow-md">Aggiungi Utente</button>
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <th class="py-2 px-4 border-b text-left">Nome</th>
            <th class="py-2 px-4 border-b text-left">Email</th>
            <th class="py-2 px-4 border-b text-left">Ruolo</th>
            <!--<th class="py-2 px-4 border-b text-left">Manager</th>-->
            <th class="py-2 px-4 border-b text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users.data" :key="user.id">
            <td class="py-2 px-4 border-b text-left">{{ user.name }}</td>
            <td class="py-2 px-4 border-b text-left">{{ user.email }}</td>
            <td class="py-2 px-4 border-b text-left">{{ user.role }}</td>
            <!--<td class="py-2 px-4 border-b text-left">{{ user.manager ? user.manager.name : '-' }}</td>-->
            <td class="py-2 px-4 border-b text-center">
              <button @click="openEditUserModal(user)" class="bg-yellow-500 text-white px-2 py-1 rounded-md mr-2">Modifica</button>
              <button @click="openDeleteUserModal(user)" class="bg-red-500 text-white px-2 py-1 rounded-md">Elimina</button>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="5"><Pagination :links="users.meta.links" /></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modale per aggiungere/modificare utente -->
    <div v-if="showUserModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-md w-full max-w-md">
        <h2 class="text-xl mb-4">{{ isEditing ? 'Modifica Utente' : 'Aggiungi Utente' }}</h2>
        <form @submit.prevent="isEditing ? updateUser() : addUser()" autocomplete="nope">
          <div class="mb-4">
            <label class="block text-gray-700">Nome</label>
            <input v-model="userForm.name" type="text" class="p93__input" required autocomplete="nope">
          </div>
          <div v-if="errors.name">{{ errors.name }}</div>
          <div class="mb-4">
            <label class="block text-gray-700">Email</label>
            <input v-model="userForm.email" type="email" class="p93__input" :class="{'bg-gray-200': isEditing}"  :required="!isEditing" :disabled="isEditing" :readonly="isEditing" autocomplete="nope">
            <div v-if="errors.email" class="pt-2 text-red-800">{{ errors.email }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Password</label>
            <input v-model="userForm.password" type="password" class="p93__input" :required="!isEditing" autocomplete="nope">
            <div v-if="errors.password" class="pt-2 text-red-800">{{ errors.password }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Ruolo</label>
            <select v-model="userForm.role" @change="onRoleChange" class="p93__input" required autocomplete="nope">
              <option v-for="role in $page.props.roles" :key="role.name" :value="role.name">{{ role.name.charAt(0).toUpperCase() + role.name.slice(1) }}</option>
            </select>
            <div v-if="errors.role" class="pt-2 text-red-800">{{ errors.role }}</div>
          </div>
          <div v-if="$page.props.customer.bridge" class="mb-4">
            <label class="block text-gray-700">Worker</label>
            <select v-model="userForm.worker" class="p93__input">
                <option v-for="worker in workers" :key="worker.WorkerID" :value="worker.WorkerID">{{ worker.Name + ' ' + worker.LastName }}</option>
            </select>
            <div v-if="errors.worker" class="pt-2 text-red-800">{{ errors.worker }}</div>
          </div>
          <div v-if="$page.props.customer.bridge" class="mb-4">
            <label class="block text-gray-700">Agente</label>
            <select v-model="userForm.agent" class="p93__input">
                <option :value="null">— Nessun agente —</option>
                <option v-for="agent in availableAgents" :key="agent.id" :value="agent.id">{{ agent.name }}</option>
            </select>
            <div v-if="errors.agent" class="pt-2 text-red-800">{{ errors.agent }}</div>
          </div>
          <!--
          <div v-if="shouldShowManagerSelection" class="mb-4">
            <label class="block text-gray-700">Manager di riferimento</label>
            <select v-model="userForm.manager_id" class="p93__input" autocomplete="nope">
              <option value="">Seleziona un manager</option>
              <option v-for="manager in managers" :key="manager.id" :value="manager.id">
                {{ manager.name }}
              </option>
            </select>
            <div v-if="errors.manager_id" class="py-4 text-red-800">{{ errors.manager_id }}</div>
          </div>
        -->
          <div class="flex justify-end">
            <button type="button" @click="closeUserModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ isEditing ? 'Aggiorna' : 'Aggiungi' }}</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modale di conferma eliminazione -->
    <div v-if="showDeleteModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-md w-full max-w-md">
        <h2 class="text-xl mb-4">Conferma Eliminazione</h2>
        <p>Sei sicuro di voler eliminare l'utente {{ userToDelete.name }}?</p>
        <div class="flex justify-end mt-4">
          <button @click="closeDeleteUserModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button @click="deleteUser" class="bg-red-500 text-white px-4 py-2 rounded-md">Elimina</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import Pagination from '@/Components/Pagination.vue';

export default {
  props: ['users', 'workers', 'agents', 'areaManagerAgents', 'errors', 'roles', 'managers', 'rolesInfo'],
  components: {
    Link,
    Pagination
  },
  data() {
    return {
      showUserModal: false,
      showDeleteModal: false,
      isEditing: false,
      userForm: useForm({
        id: null,
        name: '',
        email: '',
        password: '',
        role: 'user',
        worker: null,
        agent: null,
        manager_id: null
      }),
      userToDelete: null,
      prevRole: 'user'
    };
  },
  computed: {
    selectedRoleInfo() {
      return this.rolesInfo?.find(role => role.name === this.userForm.role);
    },
    shouldShowManagerSelection() {
      const roleInfo = this.selectedRoleInfo;
      return roleInfo && !roleInfo.is_admin && !roleInfo.is_manager;
    },
    availableAgents() {
      if (this.userForm.role === 'capoarea') {
        return this.areaManagerAgents ?? [];
      }
      return this.agents ?? [];
    }
  },
  methods: {
    onRoleChange(event) {
      const newVal = event.target.value;
      if (newVal === 'capoarea' || this.prevRole === 'capoarea') {
        this.userForm.agent = null;
      }
      this.prevRole = newVal;
    },
    resetUserForm() {
      this.userForm.reset();
      this.userForm.id = null;
      this.userForm.name = '';
      this.userForm.email = '';
      this.userForm.password = '';
      this.userForm.role = 'user';
      this.userForm.worker = null;
      this.userForm.agent = null;

      this.isEditing = false;
    },
    openAddUserModal() {
      this.resetUserForm();
      this.isEditing = false;
      this.showUserModal = true;
      this.prevRole = 'user';
    },
    openEditUserModal(user) {
      this.resetUserForm();
      this.userForm.id = user.id;
      this.userForm.name = user.name;
      this.userForm.email = user.email;
      this.userForm.role = user.role;
      this.prevRole = user.role;
      this.userForm.manager_id = user.manager_id;
      this.userForm.password = '';
      this.userForm.worker = user.worker;
      this.userForm.agent = user.agent;
      this.isEditing = true;
      this.showUserModal = true;
    },
    closeUserModal() {
      this.showUserModal = false;
    },
    addUser() {
      router.post(route('modules.core.aggiungi-utente'), this.userForm, {
        onSuccess: () => this.closeUserModal()
      });
    },
    updateUser() {
      router.post(route('modules.core.modifica-utente'), this.userForm, {
        onSuccess: () => this.closeUserModal()
      });
    },
    openDeleteUserModal(user) {
      this.userToDelete = user;
      this.showDeleteModal = true;
    },
    closeDeleteUserModal() {
      this.showDeleteModal = false;
    },
    deleteUser() {
      router.delete(route('modules.core.elimina-utente', this.userToDelete.id), {
        onSuccess: () => this.closeDeleteUserModal()
      });
    }
  }
};
</script>